// 不同国家对应的主体类型、业务类型
export const businessGenreData = {
  Singapore: [
    {
      value: "COMPANY",
      zh: "公司类",
      en: "Corporate related",
      children: [
        {
          value: "COMPANY_INCORPORATION",
          zh: "公司设立",
          en: "Company Incorporation",
        },
        {
          value: "SERVICE_TRANSFER",
          zh: "公司服务的转移 – 公司秘书相关的服务",
          en: "Corporate Service Transfer – Company Secretarial related services",
        },
        {
          value: "COMPREHENSIVE_CUSTOMIZED",
          zh: "综合性公司服务 – 定制化(不包括:公司设立)",
          en: "Comprehensive Corporate Services – Customized (Exclusive of Incorporation)",
        },
      ],
    },
    {
      value: "FUND",
      zh: "基金类",
      en: "Fund related",
      children: [
        // {
        //   value: "VCC_INCORPORATION",
        //   zh: "基金设立",
        //   en: "VCC Incorporation",
        // },
        {
          value: "FUND_ADMIN_CUSTOMIZED",
          zh: "基金托管服务 – 定制化(不包括: 基金设立)",
          en: "Fund Admin Services – Customized (Exclusive of Incorporation)",
        },
      ],
    },
  ],
  Malaysia: [
    {
      value: "COMPANY",
      zh: "公司类",
      en: "Corporate related",
      children: [
        {
          value: "COMPANY_INCORPORATION",
          zh: "公司设立",
          en: "Company Incorporation",
        },
        {
          value: "SERVICE_TRANSFER",
          zh: "公司服务的转移 – 公司秘书相关的服务",
          en: "Corporate Service Transfer – Company Secretarial related services",
        },
        {
          value: "COMPREHENSIVE_CUSTOMIZED",
          zh: "综合性公司服务 – 定制化(不包括:公司设立)",
          en: "Comprehensive Corporate Services – Customized (Exclusive of Incorporation)",
        },
      ],
    },
  ],
  "Virgin Islands, British": [
    {
      value: "COMPANY",
      zh: "公司类",
      en: "Corporate related",
      children: [
        {
          value: "COMPANY_INCORPORATION",
          zh: "公司设立",
          en: "Company Incorporation",
        },
        {
          value: "SERVICE_TRANSFER",
          zh: "公司服务的转移 – 公司秘书相关的服务",
          en: "Corporate Service Transfer – Company Secretarial related services",
        },
        {
          value: "COMPREHENSIVE_CUSTOMIZED",
          zh: "综合性公司服务 – 定制化(不包括:公司设立)",
          en: "Comprehensive Corporate Services – Customized (Exclusive of Incorporation)",
        },
      ],
    },
  ],
  "Cayman Islands": [
    {
      value: "COMPANY",
      zh: "公司类",
      en: "Corporate related",
      children: [
        {
          value: "COMPANY_INCORPORATION",
          zh: "公司设立",
          en: "Company Incorporation",
        },
        {
          value: "SERVICE_TRANSFER",
          zh: "公司服务的转移 – 公司秘书相关的服务",
          en: "Corporate Service Transfer – Company Secretarial related services",
        },
        {
          value: "COMPREHENSIVE_CUSTOMIZED",
          zh: "综合性公司服务 – 定制化(不包括:公司设立)",
          en: "Comprehensive Corporate Services – Customized (Exclusive of Incorporation)",
        },
      ],
    },
  ],
};
